import { Component, OnInit } from '@angular/core';
import { TableView } from '../../../helpers/tableview';
import { UsersService, InvoiceStatus } from "./users.service";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Profile } from './profile';

@Component({
  selector: 'app-admin-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  providers: [UsersService]
})
export class AdminUsersPage implements OnInit {

  public table: TableView;
  public invoiceStatus = InvoiceStatus;
  
  constructor(private usersService: UsersService, private modalService: NgbModal){
  }

  ngOnInit() {
      this.table = new TableView(filter => this.usersService.getUsers(filter));
      this.table.filter.status = InvoiceStatus.pending;
      this.table.filter.sortBy = "id";
      this.table.filter.sortAsc = false;
      this.table.applyFilter();
  }

  // change user Admin status (on/off)
  toggleAdminRights(item) {
    this.table.updating = this.usersService.toggleAdminRights(item.id).then(result => {
      item.admin = result;
      // if user is now Admin, it cannot be Manager or Maintainer
      if (result) {
        item.manager = false;
        item.maintainer = false;
      }
    });
  }

  // change user Manager status (on/off)
  toggleManagerRights(item) {
      this.table.updating = this.usersService.toggleManagerRights(item.id).then(result => {
        item.manager = result;
        // if user is now Manager, it cannot be Admin or Maintainer
        if (result) {
          item.admin = false;
          item.maintainer = false;
        } 
      });
  }

  // change user Maintainer status (on/off)
  toggleMaintainerRights(item) {
    this.table.updating = this.usersService.toggleMaintainerRights(item.id).then(result => {
        item.maintainer = result;
        // if user is now Maintainer, it cannot be Admin or Manager
        if (result){
          item.admin = false;
          item.manager = false;
      }
    });
  }

  // change user Banned status (on/off)
  toggleBanStatus(item) {
	  this.table.updating = this.usersService.toggleBanStatus(item.id).then(result => {
		  item.status = result;
	  });
  }

  // approve user Invoicing request
  approveInvoicing(item) {
    this.table.updating = this.usersService.approveInvoice(item.id).then(result => {
      if (result) {
        item.invoiceStatus = InvoiceStatus.approved;
      }
    });
  }

  // reject user Invoicing request
  rejectInvoicing(item) {
    this.table.updating = this.usersService.rejectInvoice(item.id).then(result => {
      if (result) {
        item.invoiceStatus = InvoiceStatus.rejected;
      }
    });
  }

  showProfile(item) {
    let modalRef = this.modalService.open(Profile, {size: "lg", windowClass: "-profile"});
    modalRef.componentInstance.user = item;   
  }

}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/admin/users/users.component.ts